import React from 'react';

const BaseIcon = function BaseIcon(_ref) {
    const color = _ref.color,
        _ref$pushRight = _ref.pushRight,
        pushRight = _ref$pushRight === undefined ? true : _ref$pushRight,
        children = _ref.children;
    return React.createElement(
        'svg',
        {
            xmlns: 'http://www.w3.org/2000/svg',
            width: '20',
            height: '20',
            viewBox: '0 0 24 24',
            fill: 'none',
            stroke: color,
            strokeWidth: '2',
            strokeLinecap: 'round',
            strokeLinejoin: 'round',
            style: {marginRight: pushRight ? '20px' : '0', minWidth: 24}
        },
        children
    );
};

const InfoIcon = function InfoIcon() {
    return React.createElement(
        BaseIcon,
        {color: '#003849'},
        React.createElement('circle', {cx: '12', cy: '12', r: '10'}),
        React.createElement('line', {x1: '12', y1: '16', x2: '12', y2: '12'}),
        React.createElement('line', {x1: '12', y1: '8', x2: '12', y2: '8'})
    );
};

const SuccessIcon = function SuccessIcon() {
    return React.createElement(
        BaseIcon,
        {color: '#86bc24'},
        React.createElement('path', {d: 'M22 11.08V12a10 10 0 1 1-5.93-9.14'}),
        React.createElement('polyline', {points: '22 4 12 14.01 9 11.01'})
    );
};

const ErrorIcon = function ErrorIcon() {
    return React.createElement(
        BaseIcon,
        {color: '#dc3545'},
        React.createElement('circle', {cx: '12', cy: '12', r: '10'}),
        React.createElement('line', {x1: '12', y1: '8', x2: '12', y2: '12'}),
        React.createElement('line', {x1: '12', y1: '16', x2: '12', y2: '16'})
    );
};

const AlertTemplate = ({ message, options, style, close }) => {

    return (
        <div className="toast fade show" style={{  ...style }}>
            <div className="toast-header">
            {options.type === 'info' && <InfoIcon />}
            {options.type === 'success' && <SuccessIcon />}
            {options.type === 'error' && <ErrorIcon />}
                <strong className="mr-auto"/>
                <small/>
                <button type="button" className="ml-2 close" onClick={close}>
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div className="toast-body">
                <strong>
                {message}
                </strong>
            </div>
        </div>
    )
}

export default AlertTemplate;
